import { Injectable } from '@angular/core';
import jwt_decode from "jwt-decode";


// import 'rxjs/Rx';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { CommonService } from 'src/app/service/common-service';
interface JwtPayload {
  Employee_Code: string;
  Clients: any;
}
@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor(private http: HttpClient) { }


  logEvent(eventName):any {
    //const token = sessionStorage.getItem('access_token');
    const token = CommonService.decryptData(sessionStorage.getItem('access_token'));
    //   const data = jwt_decode<JwtPayload>(token);
    const data = jwt_decode<JwtPayload>(token);
    data.Clients = JSON.parse(sessionStorage.getItem('access_client_data'))
    const body = {
      "EmpCode": data.Employee_Code,
      "Client_Id": data.Clients[0].Client_Id,
      "Client_Name": data.Clients[0].Client_Name,
      "EventName": eventName,
      "LinkUsed": environment.linkUsed

    }

    // console.log('logEvent body : ', body);

    return this.http.post(environment.ApiUrl + '/api/Insert_Login_Logout_Track', body)
  }

  logOutEvent(eventName):any {
    //const token = sessionStorage.getItem('access_token');
    const token = CommonService.decryptData(sessionStorage.getItem('access_token'));
       const data = jwt_decode<JwtPayload>(token);
    data.Clients = JSON.parse(sessionStorage.getItem('access_client_data'))
    const body = {
      "EmpCode": data.Employee_Code,
      "Client_Id": data.Clients[0].Client_Id,
      "Client_Name": data.Clients[0].Client_Name,
      "EventName": eventName,
      "LinkUsed": environment.linkUsed

    }

    // console.log('logEvent body : ', body);

    return this.http.put(environment.ApiUrl + '/api/Update_Login_Logout_Track', body)
  }
}
